import React from 'react'

import { NewRecipe, TempRecipe } from '@/api/types'
import { Spinner } from '@/components/Spinner'
import RecipePhotoForm from '../EditOrCreateRecipe/RecipePhotoUpload/RecipePhotoForm'
import useRecipePhoto from './useRecipePhoto'

type Props = {
  idRecipe: number
  photo?: NewRecipe | TempRecipe
}

export default function PhotoPicker({ idRecipe }: Props) {
  const { uploadPhoto, isPending } = useRecipePhoto(idRecipe)

  const handleUpdatePhoto = (photo: File) => {
    uploadPhoto(photo)
  }

  return (
    <>
      {isPending ? (
        <div className="RecipePhotoUpload-spinner">
          <Spinner />
        </div>
      ) : (
        <RecipePhotoForm updatePhoto={handleUpdatePhoto} />
      )}
    </>
  )
}
